import { find } from 'lodash';

export const resolvePeriods = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'periodsService', periodsService => {
    return periodsService.findAll(page, perpage, deleted).then(list => list);
  }];
};

export const resolvePeriod = (param = 'period') => {
  return [ '$stateParams', 'periodsService', ($stateParams, periodsService) => {
    return $stateParams[param] && $stateParams[param] > 0 ? periodsService.findById($stateParams[param]) : {};
  }];
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/resolvers/periods.resolver.js